/**
 * Plain-text content of an HTML string, for word/character counting.
 * Math nodes contribute their delimited source (e.g. `$E=mc^2$`) as one token.
 *
 * Lives here rather than in RichTextEditor so the store can use it without pulling
 * the editor (tiptap, prosemirror, KaTeX — about a third of the bundle) into the
 * entry chunk that every page downloads.
 */
export const stripHtml = (html: string): string => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent ?? '').trim();
};
